<template>
  <div class="margin-box" v-if="me">
    <div v-if="folder">
      <div class="back-to-folder" @click="$router.go(-1)">Go Back</div>
      <h1>Question List: {{ folder.title }}</h1>
    </div>

    <div>
      <el-form label-width="120px">
        <el-form-item label="Title">
          <el-input placeholder="Tile of Folder" v-model="newQuestion.title"></el-input>
        </el-form-item>
        <el-form-item label="Submit">
          <el-button type="primary" @click="addQuestion({ folderID })">Add Question</el-button>
        </el-form-item>
      </el-form>
    </div>


    <div>
      <h1>1. Download Question Template</h1>
      <div>
        <p><strong v-if="downloadLoading">Downloading...</strong></p>
        <p>
          Please download template and then copy question and answer into the template.
        </p>
        <el-button type="primary" @click="downloadTemplate()">Download Excel Template</el-button>
      </div>
    </div>

    <div>
      <h1>2. Import from template</h1>
      <div>
        <el-button type="success" @click="$refs['excel-upload-input'].click()">Upload Formatted Question</el-button>
        <input ref="excel-upload-input" style="display:none;" class="excel-upload-input" type="file" accept=".xlsx, .xls" @change="onSelectedFiles">
      </div>
      <div>
        <p style="color:blue;" v-if="uploadingExcel">Uploading Excel...</p>
      </div>
    </div>

    <div>
      <h1>Manage Question</h1>
      <div style="margin: 30px 0px;">
        <strong v-if="status === 'saving'">Saving... Don't close...</strong>
        <strong v-if="status === 'saved'">Saved to cloud...</strong>
      </div>
      <el-input
      v-model="search"
      placeholder="Type to search title"
      style="max-width: 200px;"/>
      <el-table
        border fit highlight-current-row
        :data="searcher(myQuestions, search)"
        stripe
        style="width: 100%">
        <!-- <el-table-column
          prop="title"
          label="Title"
          >
          <template slot-scope="scope" >
            <div>
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="Title"
                v-model="scope.row.title"
                @input="$emit('req-update', scope.row)">
              </el-input>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column
          prop="title"
          label="Title"
          >
          <template slot-scope="scope" >
            <div>
              <Latex :latex="scope.row.document.latex"></Latex>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          fixed="left"
          label="Edit"
          width="180">
          <template slot-scope="scope">
            <el-button @click="editQuestion({ question: scope.row })" type="text" size="medium">Edit</el-button>
            <el-button @click="tryQuestion({ question: scope.row })" type="text" size="medium">Try</el-button>
            <!-- <el-button @click="removeQuestion({ question: scope.row })" type="text" size="medium">Remove</el-button> -->
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="Operations"
          width="180">
          <template slot-scope="scope">
            <!-- <el-button @click="editQuestion({ question: scope.row })" type="text" size="medium">Edit</el-button> -->
            <!-- <el-button @click="tryQuestion({ question: scope.row })" type="text" size="medium">Try</el-button> -->
            <el-button @click="removeQuestion({ question: scope.row })" type="text" size="medium">Remove</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <div>
      <pre>{{ tempQuestion }}</pre>
      <pre>{{ myQuestions }}</pre>
      {{ folderID }}
      {{ folder }}
    </div> -->
  </div>
</template>

<script>
import * as Question from '@/api/question.js'
import * as Folder from '@/api/folders.js'
import * as Auth from '@/api/login.js'
import * as QS from '../yoqb-compos/question'
import XLSX from 'xlsx'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import Latex from '../yoqb-compos/Latex.vue'

Vue.use(ElementUI)

/*
IMPORTANT...

Local cannot find online folders
*/

export default {
  components: {
    Latex
  },
  // question-list/:folderID
  computed: {
    folderID () {
      return this.$route.params.folderID
    }
  },
  data () {
    return {
      uploadingExcel: false,
      status: 'saved',
      search: '',
      myQuestions: [],
      downloadLoading: false,

      tempQuestion: {},
      newQuestion: this.getTemplate(1),
      me: false,
      folder: false
    }
  },
  methods: {
    searcher (arr, search) {
      return arr.filter(data => {
        if (!search) {
          return true
        } else {
          let searchTitle = data.title.toLowerCase().includes(search.toLowerCase())
          return searchTitle
        }
      })
    },
    getTemplate (count) {
      return {
        title: `Question ` + (count)
      }
    },
    async removeQuestion ({ question }) {
      if (window.prompt(`Please copy and paste "${question.title}" to remove`) === question.title) {
        let resp = await Question.removeQuestion(question)
        this.listQuestion()
        console.log(resp)
      }
    },
    async editQuestion ({ question }) {
      this.$router.push(`/buhk-cloud/yoqb-maker/${question._id}`)
    },
    tryQuestion ({ question }) {
      this.$router.push(`/buhk-cloud/try-question/${question._id}`)
    },

    //
    downloadTemplate () {
      this.downloadLoading = true
      /*
      Column 1: Text MC question
      Column 2: Answer A
      Column 3: Answer B choice
      Column 4: Answer C choice
      Column 5: Answer D Choice
      Column 6: Correct Answer (only one letter A,B,C, or D)
      */
      import('./Export2Excel').then(excel => {
        const header = ['Text MC Question', 'Answer A', 'Answer B', 'Answer C', 'Answer D', 'Correct Answer', 'Explain', 'Subject']
        const keyNameList = ['question', 'ans_a', 'ans_b', 'ans_c', 'ans_d', 'realAns', 'explain', 'subject']
        const list = [
        ]
        const data = this.formatJson(keyNameList, list)
        excel.export_json_to_excel({
          header: header,
          data,
          filename: 'Question Bank Template',
          autoWidth: true,
          bookType: 'xlsx'
        })
        this.downloadLoading = false
      })
    },
    formatJson(keyNameList, list) {
      return list.map(entryData => keyNameList.map(kn => {
        if (kn === 'timestamp') {
          return parseTime(entryData[kn])
        } else {
          return entryData[kn]
        }
      }))
    },

    onSelectedFiles(e) {
      const files = e.target.files
      const rawFile = files[0] // only use files[0]
      if (!rawFile) return
      this.processThenUpload(rawFile)
    },
    async processThenUpload(rawFile) {
      let { header, results } = await this.readerData(rawFile)
      /*
      'Text MC Question', 'Answer A', 'Answer B', 'Answer C',  'Answer D', 'Correct Answer'
      */
      let excelToJSON = results.map(r => {
        // Object.keys(r)
        return {
          'latex': r[header[0]],
          'ans_a': r[header[1]],
          'ans_b': r[header[2]],
          'ans_c': r[header[3]],
          'ans_d': r[header[4]],
          'real_ans': r[header[5]].toUpperCase().trim(),
          'explain': r[header[6]],
          'subject': r[header[7]]
        }
      })

      let toDB = excelToJSON.map((excel) => {
        let qTeacher = QS.makeSampleQuestion()
        let qStudent = QS.makeSampleQuestion()
        QS.injectAnsDataByType(qTeacher, 'one-ans-mc')
        QS.injectAnsDataByType(qStudent, 'one-ans-mc')

        qTeacher.latex = excel.latex
        qTeacher.ansData.saMC.map((choice) => {
          if (choice.label.toUpperCase() === excel.real_ans.toUpperCase()) {
            choice.isRight = true
          } else {
            choice.isRight = false
          }

          if (choice.label.toUpperCase() === 'A') {
            choice.latex = excel['ans_a']
          }
          if (choice.label.toUpperCase() === 'B') {
            choice.latex = excel['ans_b']
          }
          if (choice.label.toUpperCase() === 'C') {
            choice.latex = excel['ans_c']
          }
          if (choice.label.toUpperCase() === 'D') {
            choice.latex = excel['ans_d']
          }
        })

        qTeacher.ansData.explain = excel['explain']
        qTeacher.ansData.subject = excel['subject']
        console.log(qTeacher)

        qTeacher = QS.attachQuestionOnlyData(qTeacher)
        qStudent = JSON.parse(JSON.stringify(qTeacher))

        return {
          folderID: this.folderID,
          userID: this.me._id,
          title: qTeacher.latex.slice(0, 30) + '...',
          document: qTeacher,
          questionOnly: qStudent
        }
      })

      this.uploadingExcel = true
      await Question.addQuestionBatch({ array: toDB })
      await this.listQuestion()
      window.alert('successfully uploaded')
      this.$nextTick(() => {
        this.uploadingExcel = false
      })
    },
    readerData (rawFile) {
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const fixedData = this.fixData(data)
          const workbook = XLSX.read(btoa(fixedData), { type: 'base64' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet)
          this.loading = false
          resolve({ header, results })
        }

        reader.readAsArrayBuffer(rawFile)
      })
    },
    fixData(data) {
      let o = ''
      let l = 0
      const w = 10240
      for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
      return o
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },


    async addQuestion () {
      let resp = await Question.addQuestion({ folderID: this.folderID, userID: this.me._id, title: this.newQuestion.title, document: QS.makeSampleQuestion(), questionOnly: QS.makeSampleQuestion() })
      this.tempQuestion = resp.data
      this.listQuestion()
      this.$router.push(`/buhk-cloud/yoqb-maker/${resp.data._id}`)
    },
    async myself () {
      let resp = await Auth.getUserInfo()
      this.me = resp.data
      this.$forceUpdate()
    },
    async getFolder () {
      let resp = await Folder.getFolder({ _id: this.folderID })
      this.folder = resp.data
      this.$forceUpdate()
    },
    async listQuestion () {
      let resp = await Question.listFolderQuestion({ folderID: this.folderID })
      this.myQuestions = resp.data
      this.newQuestion = this.getTemplate(this.myQuestions.length + 1)
      // this.tempQuestion = this.getTemplate(this.myQuestions.length + 1)
    }
  },
  async mounted () {
    this.myself()
    this.getFolder()
    this.listQuestion()

    this.$on('update', async (item) => {
      // Question
      this.status = 'saving'
      await Question.updateQuestion(item)
      this.status = 'saved'
    })
    let tt = 0
    this.$on('req-update', (item) => {
      // Question
      this.status = 'saving'
      clearTimeout(tt)
      tt = setTimeout(async () => {
        await Question.updateQuestion(item)
        this.status = 'saved'
      }, 600)
    })
  }
}
</script>

<style scoped>

.question-row{
  height: 40px;
}

.margin-box{
  background: white;
  margin: 25px;
  padding: 15px;
}

.back-to-folder{
  text-align: center;
  font-size: 25;
  background-color: rgba(91, 100, 120, 0.763);
  color: white;
  border-radius: 3px;
  margin: 10px 30px;
  margin-left: 0px;
  padding: 10px 20px;
  cursor: pointer;
  display: inline-block;
}
</style>
